import { handleActions } from "redux-actions";
import {
  SET_LOADING,
  SET_PREV_PAGE_FILTERS,
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_LEADS_SUCCESS
} from "./leadsAddedSagas";

export const initialState = {
  leads: {},
  prevPageFilters: { prevDate: null },
  initRequest: false,
  profilesYearOverYearComparison: [],
  initialized: false,
  isLoading: true
};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload || state.currentUser,
      initRequest: true
    }),
    [SET_PREV_PAGE_FILTERS]: (state, action) => ({
      ...state,
      prevPageFilters: { ...action.payload }
    }),
    [FETCH_LEADS_SUCCESS]: (state, action) => ({
      ...state,
      initialized: action.payload.initialized || state.initialized,
      leads: action.payload.profiles || state.leads,
      profilesYearOverYearComparison:
        action.payload.profilesYearOverYearComparison || state.profilesYearOverYearComparison
    })
  },
  initialState
);
